import { useContext, useState, FC, ReactElement, useEffect } from 'react'

import { UploadFile } from 'types'
import UploadManagerContext, { UploadManagerContextType } from './Context'
import { UploadProps } from '../..'

type Props = UploadProps & {
  children: ReactElement
}

const UploadManagerProvider: FC<Props> = ({ children, onUpload, acceptFileSize, acceptFileExtension }) => {
  const [file, setFile] = useState<UploadFile>({})

  useEffect(() => {
    async function loadAsyncFunction() {
      await onUpload(file)
    }

    if (file.name) loadAsyncFunction()
  }, [file])

  return (
    <UploadManagerContext.Provider
      value={{
        file,
        setFile,
        acceptFileSize,
        acceptFileExtension,
      }}
    >
      {children}
    </UploadManagerContext.Provider>
  )
}

export default UploadManagerProvider

export const useUploadManager = () => useContext<UploadManagerContextType>(UploadManagerContext)
